import React, { useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import PropTypes, { string, object, bool, func } from 'prop-types';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { NoResultsFoundBanner } from '@thd-olt-component-react/no-results-found-banner';
import { Row, Col } from '@thd-olt-component-react/grid';
import { RelatedSearch } from '@thd-olt-component-react/related-search';
import { ShopByCategory } from '@thd-olt-component-react/shop-by-category';
import { SponsoredCarousel } from '@thd-olt-component-react/sponsored-content';
import { PlpRecsRenderPlaceholder } from '@thd-olt-component-react/thd-recs-containers';
import './no-results-found.scss';

const NoResultsFound = ({
  keyword,
  searchData,
  searchError,
  searchLoading,
  storeId,
  cpoOnly,
  onCpoClick,
  isCategory,
  pageType,
  requestKey
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('no-results-found.ready'); }, []);

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.trigger('no-results.loaded', { keyword });
    }
  }, []);

  const { channel } = useContext(ExperienceContext);

  const isMobile = channel === 'mobile';

  const crumbs = [
    { label: 'Text Search', url: '' },
    { label: keyword, url: `/s/${keyword}?NCNI-5` }
  ];

  return (
    <div className="no-results-found">
      <Row className="isBound">
        <Col xs="12" sm="12" md="12">
          <Breadcrumbs staticCrumbs={crumbs} hideOnNoCategory={isMobile} />
          <NoResultsFoundBanner keyword={keyword} cpoOnly={cpoOnly} onCpoClick={onCpoClick} />
          {searchData && (
            <RelatedSearch
              searchData={searchData}
              searchError={searchError}
              searchLoading={searchLoading}
              storeId={storeId}
            />
          )}
          <div>
            <PlpRecsRenderPlaceholder
              requestKey={requestKey}
              keyword={keyword}
            />
          </div>
          <ShopByCategory />
          <div>
            <SponsoredCarousel
              pageContext={{
                label: 'no-results-found',
                schema: 'no_results_found_sponsored',
                data: searchData,
                keyword,
                isCategory,
                isBrowse: pageType === 'browse',
                isSearch: pageType === 'search'
              }}
              showSponsoredCarousel
              dynamic={{
                pageType
              }}
              hydrator={{
                className: 'grid',
                scrollBuffer: 750
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

NoResultsFound.displayName = 'NoResultsFound';

NoResultsFound.propTypes = {
  keyword: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  searchData: object,
  // eslint-disable-next-line react/forbid-prop-types
  searchError: object,
  searchLoading: bool,
  storeId: string,
  cpoOnly: bool,
  onCpoClick: func,
  pageType: string,
  isCategory: bool,
  requestKey: string,
};

NoResultsFound.defaultProps = {
  searchData: undefined,
  searchError: undefined,
  searchLoading: undefined,
  storeId: null,
  cpoOnly: false,
  onCpoClick: () => {},
  pageType: '',
  isCategory: false,
  requestKey: ''
};

export { NoResultsFound };
